
import { BaseModel } from '../abstracts/base.model'

export class LoginModel extends BaseModel {
  TenantCode: string = '27200'
  Username: string
  Password: string
  grant_type: string = 'password'
  RememberMe: boolean = false;
}